import moduleDescriptions from 'root/src/shared/descriptions/modules'
import pathOr from 'ramda/src/pathOr'
import always from 'ramda/src/always'
import is from 'ramda/src/is'

export default (state, { moduleId }) => {
	const linksSelector = pathOr(always(undefined), [moduleId, 'links'], moduleDescriptions)

	if (!linksSelector) {
		return undefined
	}

	return is(Function, linksSelector) ? linksSelector(state) : linksSelector
}
